<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	import { getCountryDisplayName, getFlagEmoji } from '$lib';

	const {
		siblings,
		currentCountry,
		...rest
	}: { siblings: Config['siblings']; currentCountry: string } & HTMLAttributes<HTMLDivElement> =
		$props();

	let isOpen = $state(false);

	function outside(node: HTMLElement) {
		const handle = (e: MouseEvent) => {
			if (isOpen && !node.contains(e.target as Node)) {
				isOpen = false;
			}
		};
		document.addEventListener('mousedown', handle);
		return {
			destroy() {
				document.removeEventListener('mousedown', handle);
			},
		};
	}
</script>

{#if siblings.length > 1}
	<div {...rest} class={['relative min-w-fit', rest.class]} use:outside>
		<button
			type="button"
			onclick={() => (isOpen = !isOpen)}
			class="flex cursor-pointer items-center text-2xl"
		>
			<span>
				{getFlagEmoji(currentCountry)}
			</span>
			<span class={['icon-[mdi--chevron-down] text-lg transition', { 'rotate-180': isOpen }]}
			></span>
		</button>

		{#if isOpen}
			<div
				class="absolute top-full right-0 z-100 mt-2 max-h-72 min-w-60
				cursor-auto overflow-y-auto rounded border border-gray-300 bg-white shadow-xl"
			>
				{#each siblings as config (config.base_url)}
					{@const [lang, country] = config.locale.split('_')}
					{#if country !== currentCountry}
						<a
							href={config.base_url}
							class="flex w-full cursor-pointer items-center gap-2 px-5 py-3 text-left whitespace-nowrap hover:bg-neutral-200"
						>
							<span>{getFlagEmoji(country)}</span>
							<span>{getCountryDisplayName(country, lang)}</span>
						</a>
					{/if}
				{/each}
			</div>
		{/if}
	</div>
{/if}
